import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { graphqlRequest } from '../../services/graphql-service';
import { GET_ALL_TRACKS, GET_TRACKS_BY_IDS } from '../../config/queries.js';
import './tracks.css';
import FeaturedTracksCarosel from '../featured-tracks-carosel/featured-tracks-carosel';
import SearchFilter from '../search-filter/search-filter';
import TrackList from '../track-list/track-list';
import { 
    Divider, 
} from '@mui/material';
// import { useTheme } from '@mui/material/styles';
import Footer from '../footer/footer';
import { setVoxAuthDialogVisible } from '../../features/dialogControl/dialogControlSlice';
import { featured_tracks_ids } from '../../config/constants.js';



const Tracks = () => {
    // const theme = useTheme();
	const [tracksData, setTracksData] = useState(null);
	const [featuredTracks, setFeaturedTracks] = useState(null);
	const [filteredTracks, setFilteredTracks] = useState(tracksData);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [isBlurred, setIsBlurred] = useState(true);
    const dispatch = useDispatch();

    // Check if user is logged in
    useEffect(() => {
        const user = JSON.parse(localStorage.getItem('mb-auth'));
        if (user) {
                setIsBlurred(false);
        } else {
            setIsBlurred(true);
            dispatch(setVoxAuthDialogVisible(true)); 
        }
    }, [dispatch]);

    // Populate the tracks list
    useEffect(() => {
        const fetchTracksData = async () => {
            try {
                setLoading(true);
                const data = await graphqlRequest(GET_ALL_TRACKS, {}); 
                const sortedData = data.tracks.sort( (a,b) => a.title.localeCompare(b.title));
                setTracksData(sortedData);
                setFilteredTracks(sortedData)
                const featured_data = await graphqlRequest(GET_TRACKS_BY_IDS, { trackIds: featured_tracks_ids }); 
                selectFeaturedTracks(featured_data.tracksByIds);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        const selectFeaturedTracks = (tracks) => {
            // TODO: this should be driven by some sort of db table
            const featuresLength = 10;
            const shuffledArray = [...tracks];
            for (let i = shuffledArray.length - 1; i > 0; i--) {
              const j = Math.floor(Math.random() * (i + 1));
              [shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]]; // Swap elements
            }
            const data = shuffledArray.slice(0,featuresLength)
            setFeaturedTracks(data);
        }
		
        fetchTracksData();
    }, []);

    const handleFilter = (filteredData) => {
        setFilteredTracks(filteredData);
    }
    
    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error}</p>;

	return (
		<div className='tracks-container'>

            {isBlurred && <div className="blurred-overlay"></div>}
			
            <div className='tracks-features-container'>
                <div className='tracks-features-banner'>
                    Featured Releases
                </div>
                <FeaturedTracksCarosel trackList={featuredTracks} />
            </div>
            <Divider />
            <SearchFilter data={tracksData} onFilterChange={handleFilter} />
            <Divider />
            <div className='artist-list-banner'>Tracks</div>
			<div className='tracks-container-inner'>
                <TrackList trackList={filteredTracks} />
			</div>
            <Footer />
		</div>
  	)
}

export default Tracks